const SERVER_URL_BASE = "https://iot.union-shield.com";
const SERVER_URL = SERVER_URL_BASE + "/api/v1";
const MONITOR_URL = SERVER_URL;
const BLOG_URL = "";

export const API = {
    ROOT: SERVER_URL + '/web',
    LOGIN: SERVER_URL + '/web/login',
    TOKEN: SERVER_URL + '/web/token/refresh',
    REGISTER: SERVER_URL + '/web/register',
    RETRIEVE: SERVER_URL + '/web/retrieve',
    LOGOUT: SERVER_URL + "/web/token/logout",
    USER_INFO: SERVER_URL + "/web/me/detail",
    USER_BOUND_LIST: SERVER_URL + "/web/me/bound_list",
    AVATAR: SERVER_URL_BASE + '/avatar/',
    IMAGES: SERVER_URL_BASE + '/images/',
    SMSCODE: SERVER_URL + '/web/sms',
    USER: SERVER_URL + '/web/users',
    DEVICE: SERVER_URL + '/web/devices',
    DEVICE_LOG: SERVER_URL + "/web/user/device/cloud_storage/logs",
    DEVICE_OBJECT: SERVER_URL + "/web/user/device/cloud_storage/object",
    DATA: SERVER_URL + '/web/data',
    DEVICE_USER: SERVER_URL + '/web/users/devices',
    PRODEVICE: SERVER_URL + '/web/dev',
    OTA: SERVER_URL + '/web/ota',
    APP: 'http://localhost:3000/' + 'apkfile',
    APP_UPLOAD: 'http://localhost:3000/' + 'apkfile/upload',
    PROFILE: SERVER_URL + '/web/dev/user',
    AUTH: SERVER_URL + '/web/dev/auth',
    MESSAGE: SERVER_URL + '/web/message',
    FEEDBACK: SERVER_URL + '/web/feedback',
    REVIEW: SERVER_URL + '/web/review',
    MONITOR: SERVER_URL + "/web/dashboard/count",
    SETTINGS: SERVER_URL + "/web/settings",
    NOTICE: SERVER_URL + "/web/dashboard/notice",
    ACKEYS: SERVER_URL + "/web/ackeys",
    USERKEYS: SERVER_URL + "/web/user_keys",
    ORDER: SERVER_URL + "/web/orders",
    PAY: SERVER_URL + "/web/order/trade_pay",
    CHECK_PAY: SERVER_URL + "/web/order/pay_status",
    LIMIT_LIST: SERVER_URL + "/web/user/access/control/list",

    // 厂商管理API
    VENDORS: SERVER_URL + "/web/vendors",

    PROFILE_PASSWORD:SERVER_URL + "/web/home/password",
    PROFILE_PHONE:SERVER_URL + "/web/home/phone",
    PROFILE_SMS:SERVER_URL + "/web/sms",

    ADMIN_USER_LIST: SERVER_URL + '/web/admin/users',
    ADMIN_USER: SERVER_URL + '/web/admin/user',

    WORDPRESS: {
        POST_LIST: BLOG_URL + "/posts?categories=144&context=embed&per_page=5",
        POST: BLOG_URL + "/posts/",
        MORE: ""
    },
    // SERVICE_STATE_OVERVIEW: SERVER_URL + "/web/services/overview",
    // 使用实时监控API - 直接从Supervisor获取状态
    SERVICE_STATE_LIST: MONITOR_URL + "/web/services/realtime",
    // 备选: 使用混合模式(注册信息+实时状态)
    // SERVICE_STATE_LIST: MONITOR_URL + "/web/services/list-with-status?page=1&perPage=30",
}